var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19828_75216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.46333 11.9595C7.91583 10.6812 10.5 8.06952 10.5 5.67285C10.5 4.34677 9.97322 3.075 9.03553 2.13732C8.09785 1.19964 6.82608 0.672852 5.5 0.672852C4.17392 0.672852 2.90215 1.19964 1.96447 2.13732C1.02678 3.075 0.5 4.34677 0.5 5.67285C0.5 8.06952 3.08333 10.6812 4.53667 11.9595C4.80176 12.1961 5.14467 12.3269 5.5 12.3269C5.85533 12.3269 6.19824 12.1961 6.46333 11.9595ZM3.83333 5.67285C3.83333 5.23082 4.00893 4.8069 4.32149 4.49434C4.63405 4.18178 5.05797 4.00619 5.5 4.00619C5.94203 4.00619 6.36595 4.18178 6.67851 4.49434C6.99107 4.8069 7.16667 5.23082 7.16667 5.67285C7.16667 6.11488 6.99107 6.5388 6.67851 6.85136C6.36595 7.16392 5.94203 7.33952 5.5 7.33952C5.05797 7.33952 4.63405 7.16392 4.32149 6.85136C4.00893 6.5388 3.83333 6.11488 3.83333 5.67285Z",
    fill: "#328734"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19828_75216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 11.6541,
    fill: "white",
    transform: "translate(0.5 0.672852)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationGreenIcon);
export default __webpack_public_path__ + "static/media/location_green_icon.79430308df0b92d0c38ae3788004e311.svg";
export { ForwardRef as ReactComponent };